import { Label } from '@/components/ui/label.js';
import { Final14DayProtectedBadge } from '@/routes/_layout/student-groups/-components/protected-period-override-fields.js';
import type { AttendancePolicyV2Allowance } from '@airreading/common/data';

import { AttendancePolicyV2StatusBadge } from './status-badge.js';

interface TeacherAttendanceEditStatusProps {
  policy: AttendancePolicyV2Allowance | null | undefined;
  /** Already-labeled V1 value. Omit when the assignment has no stored V1 status. */
  legacyStatusLabel?: string | null;
}

export function TeacherAttendanceEditStatus({ policy, legacyStatusLabel }: TeacherAttendanceEditStatusProps) {
  return (
    <>
      <div className="col-span-2 space-y-2 py-4">
        <div className="flex gap-2 items-center">
          <Label className="font-bold">Attendance status</Label>
        </div>
        {policy ? (
          <div className="flex flex-wrap items-center gap-2" data-testid="teacher-attendance-modal-attendance-status">
            <span className="inline-flex">
              <AttendancePolicyV2StatusBadge
                actionLevel={policy.actionLevel}
                secondaryStatuses={policy.secondaryStatuses}
                escalationCounts={{
                  noShowCount: policy.noShowCount,
                  lateEntryCount: policy.lateEntryCount,
                  earlyExitCount: policy.earlyExitCount,
                  totalSubRequestUsage: policy.totalSubRequestUsage,
                  totalSubRequestAllowance: policy.totalSubRequestAllowance,
                  shortNoticeSubRequestUsage: policy.shortNoticeSubRequestUsage,
                  shortNoticeSubRequestAllowance: policy.shortNoticeSubRequestAllowance,
                }}
                data-testid="teacher-attendance-modal-badge-action-level"
              />
            </span>
            <Final14DayProtectedBadge attendancePolicyV2={policy} />
          </div>
        ) : (
          <p className="text-[#64748B]" data-testid="teacher-attendance-modal-attendance-status">
            -
          </p>
        )}
      </div>
      {legacyStatusLabel ? (
        <div className="col-span-2 space-y-2 py-4">
          <div className="flex gap-2 items-center">
            <Label className="font-bold">Legacy V1 attendance status</Label>
          </div>
          <p className="text-[#64748B]" data-testid="teacher-attendance-modal-text-legacy-status">
            {legacyStatusLabel}
          </p>
        </div>
      ) : null}
    </>
  );
}
